import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSortIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16.29 14.29 12 18.59l-4.29-4.3a1.0041 1.0041 0 1 0-1.42 1.42l5 5a.9997.9997 0 0 0 1.42 0l5-5a1.0044 1.0044 0 0 0 .2177-1.0942 1.0044 1.0044 0 0 0-1.3119-.5435 1.0044 1.0044 0 0 0-.3258.2177ZM7.71 9.71 12 5.41l4.29 4.3a1.001 1.001 0 0 0 .71.2958 1.0003 1.0003 0 0 0 .71-.2958 1.001 1.001 0 0 0 .2958-.71.9994.9994 0 0 0-.2958-.71l-5-5a1.001 1.001 0 0 0-.71-.2958 1.0003 1.0003 0 0 0-.71.2958l-5 5a1.0041 1.0041 0 0 0 1.42 1.42Z"/>
  </SvgIcon>
}

export default LineSortIcon
